<form #userForm="ngForm" (ngSubmit)="saveChanges()">
  <div class="profile-container">
    <div class="profile-header">
      <div>
        <h2 class="profile-title">Mi Perfil</h2>
        <p class="section-description">Phoenix Dashboard / Editar Perfil</p>
      </div>
      <div class="edit-toggle-container">
        <span (click)="isGeneralEditMode() ? saveChanges() : toggleGeneralEdit()" [ngClass]="isGeneralEditMode() ? 'btn-save' : 'btn-edit'">
          {{ isGeneralEditMode()? 'Guardar' : 'Editar' }}
        </span>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="profile-progress-container">
      <p class="progress-text">Perfil completado al {{ calculateProfileProgress() }}%</p>
      <div class="progress-bar">
        <div class="progress-bar-fill" [style.width.%]="calculateProfileProgress()"></div>
      </div>
    </div>

    <!-- Sección de perfil -->
    <section class="section-header-container">
      <div class="profile-main-card">
        <!-- Card de la foto de perfil -->
        <div class="profile-photo-card">
          <div class="profile-photo" *ngIf="profilePhotoUrl">
            <img [src]="profilePhotoUrl" alt="Foto de perfil" />
            <div class="photo-upload-overlay" *ngIf="isEditMode">
              <input type="file" id="photoFile" name="photoFile" accept="image/*" (change)="onPhotoSelected($event)"
                #photoFileInput style="display: none;" />
              <button type="button" class="btn-upload-overlay" (click)="photoFileInput.click()">
                <i class="fa-solid fa-upload"></i>
              </button>
            </div>
          </div>
          <div class="profile-photo no-photo" *ngIf="!profilePhotoUrl">
            <i class="fa-solid fa-user"></i>
            <div class="photo-upload-overlay" *ngIf="isEditMode">
              <input type="file" id="photoFileNoImage" name="photoFileNoImage" accept="image/*"
                (change)="onPhotoSelected($event)" #photoFileNoImageInput style="display: none;" />
              <button type="button" class="btn-upload-overlay" (click)="photoFileNoImageInput.click()">
                <i class="fa-solid fa-upload"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Card de información personal -->
        <div class="profile-info-card">
          <div class="card-header">
            <h3 class="card-title">Mi cuenta</h3>
          </div>

          <!-- Vista de solo lectura -->
          <div class="info-grid" *ngIf="!isEditMode">
            <div class="info-item">
              <span class="label">Nombres y Apellidos</span>
              <span class="value">{{ user.firstName }}</span>
            </div>
            <!-- <div class="info-item">
              <span class="label">Apellidos</span>
              <span class="value">{{ user.lastName }}</span>
            </div> -->
            <div class="info-item">
              <span class="label">Correo electrónico</span>
              <span class="value">{{ user.email }}</span>
            </div>
            <div class="info-item">
              <span class="label">Número de teléfono</span>
              <span class="value">+{{ user.codePhone }} {{ user.phone }}</span>
            </div>
            <div class="info-item">
              <span class="label">URL de LinkedIn</span>
              <span class="value">
                <a *ngIf="user.profile?.LinkedInURL" [href]="user.profile.LinkedInURL" target="_blank"
                  class="linkedin-link">
                  {{ user.profile.LinkedInURL }}
                </a>
                <span *ngIf="!user.profile?.LinkedInURL">-</span>
              </span>
            </div>
          </div>

          <!-- Vista de edición -->
          <div class="edit-form" *ngIf="isEditMode">
            <!-- Primera fila: Nombre y apellido | Correo electrónico -->
            <div class="form-row">
              <div class="form-group">
                <label>Nombre y apellido <span class="required-asterisk">*</span></label>
                <input type="text" name="name" [(ngModel)]="user.firstName" readonly class="form-input blocked"
                  placeholder="Nombre y Apellido bloqueado" />
              </div>
              <div class="form-group">
                <label>Correo electrónico <span class="required-asterisk">*</span></label>
                <input type="email" name="email" [(ngModel)]="user.email" readonly class="form-input blocked"
                  placeholder="Correo electrónico bloqueado" />
              </div>
            </div>

            <!-- Segunda fila: Número de celular | URL de LinkedIn -->
            <div class="form-row">
              <div class="form-group">
                <label>Número de celular
                  <!-- <span class="required-asterisk">*</span> -->
                </label>
                <input type="tel" name="phone" [(ngModel)]="user.phone" class="form-input"
                  placeholder="Ingrese número de celular" pattern="[0-9]*" maxlength="9" inputmode="numeric"
                  (keypress)="onlyNumbers($event)" />
              </div>
              <div class="form-group">
                <label>URL de LinkedIn</label>
                <input type="url" name="linkedInURL" [(ngModel)]="user.profile.LinkedInURL" class="form-input"
                  placeholder="https://www.linkedin.com/in/tu-perfil" pattern="https?://.*linkedin\.com.*" />
              </div>
            </div>

            <div class="change-password-link">
              <a href="#" class="password-link">Cambiar contraseña</a>
            </div>
          </div>
        </div>
      </div>
      <!-- </section> -->

      <!-- Sección profesional -->
      <!-- <section class="section-container"> -->
      <div class="section-header">
        <h2 class="section-title"></h2>
      </div>

      <!-- Vista de solo lectura -->
      <div class="section-content" *ngIf="!isProfessionalEditMode">
        <div class="info-item">
          <span class="label">{{ (user.profile?.registerQuestions?.[3]?.title || 'Situación laboral') + 'Tu respuesta es confidencial y solo se usa para personalizar tu experiencia.' }}</span>
          <span class="value">{{ getSituacionLaboralText() || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ user.profile?.registerQuestions?.[4]?.title || 'Rango salarial Mensual' }}</span>
          <span class="value">{{ getSalaryRangeText() || '-' }}</span>
        </div>

        <!-- Campos para trabajadores activos -->
        <div class="section-content" *ngIf="shouldShowWorkerFields()">
          <div class="info-item">
            <span class="label">¿En qué industria del sector trabajas?</span>
            <span class="value">{{ getIndustryText() || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ user.profile?.registerQuestions?.[5]?.title || '¿Qué rol desempeñas actualmente?'
              }}</span>
            <span class="value">{{ getRoleText() || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Qué objetivos profesionales o de desarrollo personal te gustaría alcanzar en los
              próximos 12 meses?</span>
            <span class="value">{{ user.professionalSection?.skills || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">¿Qúe habilidades profesionales te interesa desarrollar en los próximos 3 meses?</span>
            <span class="value">{{ user.professionalSection?.skillsNow || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Qúe habilidades profesionales te interesaria desarrolllar en los siguientes 12
              meses?</span>
            <span class="value">{{ user.professionalSection?.skillsFuture || '-' }}</span>
          </div>
        </div>

        <!-- Campos para retirados -->
        <div *ngIf="shouldShowRetiredFields()">
          <div class="info-item">
            <span class="label">¿Cuál fue tu último cargo?</span>
            <span class="value">{{ user.professionalSection?.ultimoCargo || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">¿En qué empresa?</span>
            <span class="value">{{ user.professionalSection?.ultimaEmpresa || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Qué objetivos profesionales o de desarrollo personal te gustaría alcanzar en los
              próximos 12 meses?</span>
            <span class="value">{{ user.professionalSection?.skills || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">¿Qúe habilidades profesionales te interesa desarrollar en los próximos 3 meses?</span>
            <span class="value">{{ user.professionalSection?.skillsNow || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Qúe habilidades profesionales te interesaria desarrolllar en los siguientes 12
              meses?</span>
            <span class="value">{{ user.professionalSection?.skillsFuture || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- Vista de edición -->
      <div class="section-content edit-mode" *ngIf="isProfessionalEditMode">
        <!-- Primera fila - Situación laboral y Rango salarial -->
        <div class="form-grid">
          <div class="form-group">
            <label>{{ (user.profile?.registerQuestions?.[3]?.title || 'Situación laboral') + 'Tu respuesta es confidencial y solo se usa para personalizar tu experiencia.' }}<span
                class="required">*</span></label>
            <select name="situacionLaboral" [(ngModel)]="user.profile.registerQuestions[3].value" class="form-select"
              required>
              <option value="" disabled selected>Seleccione una opción</option>
              <option *ngFor="let option of getSituacionLaboralOptions()" [value]="option">{{ option }}</option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ user.profile?.registerQuestions?.[4]?.title || 'Rango salarial Mensual (USD)' }}<span
                class="required">*</span></label>
            <select name="salaryRange" [(ngModel)]="user.profile.registerQuestions[4].value" class="form-select"
              required>
              <option value="" disabled selected>Seleccione una opción</option>
              <option *ngFor="let option of getSalaryRangeOptions()" [value]="option">{{ option }}</option>
            </select>
          </div>
        </div>

        <!-- Campos condicionales para trabajadores activos (Dependiente o Independiente) -->
        <div *ngIf="shouldShowWorkerFields()">
          <!-- Segunda fila - Industria y Rol -->
          <div class="form-grid">
            <div class="form-group">
              <label>¿En qué industria del sector trabajas? <span class="required">*</span></label>
              <div class="custom-multiselect">
                <div class="multiselect-header" (click)="toggleIndustryDropdown()">
                  <span class="multiselect-placeholder">{{ getIndustryPlaceholder() }}</span>
                  <i class="fa-solid fa-chevron-down" [class.rotated]="showIndustryDropdown"></i>
                </div>
                <div class="multiselect-dropdown" *ngIf="showIndustryDropdown">
                  <div class="multiselect-options">
                    <div *ngFor="let option of industryOptions.slice(0, -1)" class="multiselect-option">
                      <input type="checkbox" [id]="'industry-' + option" [checked]="isIndustrySelected(option)"
                        (change)="onIndustryChange(option, $event)" name="industry" />
                      <label [for]="'industry-' + option">{{ option }}</label>
                    </div>
                    <div class="multiselect-option other-option" (click)="$event.stopPropagation()">
                      <input type="radio" id="industry-otro" [checked]="showOtherIndustry"
                        (change)="toggleOtherIndustry($event)" (click)="$event.stopPropagation()" name="industry" />
                      <label for="industry-otro" (click)="$event.stopPropagation()">Otro:</label>
                      <input type="text" name="otherIndustry" [(ngModel)]="otherIndustry"
                        (ngModelChange)="onOtherIndustryChange()" (click)="$event.stopPropagation()" class="other-input"
                        placeholder="" [disabled]="!showOtherIndustry" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>{{ user.profile?.registerQuestions?.[5]?.title || '¿Qué rol desempeñas actualmente?' }} <span
                  class="required">*</span></label>
              <select name="job" [(ngModel)]="user.profile.registerQuestions[5].value" class="form-select">
                <option value="" disabled selected>Seleccione una opción</option>
                <option *ngFor="let option of getRoleOptions()" [value]="option">{{ option }}</option>
              </select>
            </div>
          </div>

          <!-- Tercera fila - Metas profesionales (textarea) -->
          <div class="form-group full-width">
            <label>Qué objetivos profesionales o de desarrollo personal te gustaría alcanzar en los próximos 12 meses?
              <!-- <span class="required">*</span> -->
            </label>
            <textarea name="professionalGoals" [(ngModel)]="user.professionalSection.skills" class="form-textarea"
              placeholder="Describe tus metas profesionales o de aprendizaje" rows="4"></textarea>
          </div>

          <!-- Cuarta fila - Habilidades actuales y futuras (multiselect) -->
          <div class="form-grid">
            <div class="form-group">
              <label>¿Qúe habilidades profesionales te interesa desarrollar en los próximos 3 meses?
                <!-- <span class="required">*</span> -->
              </label>
              <div class="custom-multiselect">
                <div class="multiselect-header" (click)="toggleSkillsNowDropdown()">
                  <span class="multiselect-placeholder">{{ getSkillsNowPlaceholder() }}</span>
                  <i class="fa-solid fa-chevron-down" [class.rotated]="showSkillsNowDropdown"></i>
                </div>
                <div class="multiselect-dropdown" *ngIf="showSkillsNowDropdown">
                  <div class="multiselect-options">
                    <div *ngFor="let skill of skillsOptions.slice(0, -1)" class="multiselect-option">
                      <input type="checkbox" [id]="'skillNow-' + skill" [checked]="isSkillNowSelected(skill)"
                        (change)="onSkillNowChange(skill, $event)" />
                      <label [for]="'skillNow-' + skill">{{ skill }}</label>
                    </div>
                    <div class="multiselect-option other-option">
                      <input type="radio" id="skillNow-otro" [checked]="showOtherSkillNow"
                        (change)="toggleOtherSkillNow($event)" />
                      <label for="skillNow-otro">Otro:</label>
                      <input type="text" name="otherSkillNow" [(ngModel)]="otherSkillNow"
                        (ngModelChange)="updateSkillsNowString()" class="other-input" placeholder=""
                        [disabled]="!showOtherSkillNow" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>Qúe habilidades profesionales te interesaria desarrolllar en los siguientes 12 meses?
                <!-- <span class="required">*</span> -->
              </label>
              <div class="custom-multiselect">
                <div class="multiselect-header" (click)="toggleSkillsFutureDropdown()">
                  <span class="multiselect-placeholder">{{ getSkillsFuturePlaceholder() }}</span>
                  <i class="fa-solid fa-chevron-down" [class.rotated]="showSkillsFutureDropdown"></i>
                </div>
                <div class="multiselect-dropdown" *ngIf="showSkillsFutureDropdown">
                  <div class="multiselect-options">
                    <div *ngFor="let skill of skillsOptions.slice(0, -1)" class="multiselect-option">
                      <input type="checkbox" [id]="'skillFuture-' + skill" [checked]="isSkillFutureSelected(skill)"
                        (change)="onSkillFutureChange(skill, $event)" />
                      <label [for]="'skillFuture-' + skill">{{ skill }}</label>
                    </div>
                    <div class="multiselect-option other-option">
                      <input type="radio" id="skillFuture-otro" [checked]="showOtherSkillFuture"
                        (change)="toggleOtherSkillFuture($event)" />
                      <label for="skillFuture-otro">Otro:</label>
                      <input type="text" name="otherSkillFuture" [(ngModel)]="otherSkillFuture"
                        (ngModelChange)="updateSkillsFutureString()" class="other-input" placeholder=""
                        [disabled]="!showOtherSkillFuture" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Campos condicionales para retirados -->
        <div *ngIf="shouldShowRetiredFields()">
          <div class="form-grid">
            <div class="form-group">
              <label>¿Cuál fue tu último cargo? <span class="required">*</span></label>
              <select name="ultimoCargo" [(ngModel)]="user.professionalSection.ultimoCargo" class="form-select">
                <option value="" disabled selected>Seleccione una opción</option>
                <option *ngFor="let option of getRoleOptions()" [value]="option">{{ option }}</option>
              </select>
            </div>

            <div class="form-group">
              <label>¿En qué empresa? <span class="required">*</span></label>
              <input type="text" name="ultimaEmpresa" [(ngModel)]="user.professionalSection.ultimaEmpresa"
                class="form-input" placeholder="Nombre de la empresa" />
            </div>
            <!-- Tercera fila - Metas profesionales (textarea) -->
            <div class="form-group full-width">
              <label>Qué objetivos profesionales o de desarrollo personal te gustaría alcanzar en los próximos 12 meses?
                <!-- <span class="required">*</span> -->
              </label>
              <textarea name="professionalGoals" [(ngModel)]="user.professionalSection.skills" class="form-textarea"
                placeholder="Describe tus metas profesionales o de aprendizaje" rows="4"></textarea>
            </div>

            <!-- Cuarta fila - Habilidades actuales y futuras (multiselect) -->
            <div class="form-grid">
              <div class="form-group">
                <label>¿Qúe habilidades profesionales te interesa desarrollar en los próximos 3 meses?
                  <!-- <span class="required">*</span> -->
                </label>
                <div class="custom-multiselect">
                  <div class="multiselect-header" (click)="toggleSkillsNowDropdown()">
                    <span class="multiselect-placeholder">{{ getSkillsNowPlaceholder() }}</span>
                    <i class="fa-solid fa-chevron-down" [class.rotated]="showSkillsNowDropdown"></i>
                  </div>
                  <div class="multiselect-dropdown" *ngIf="showSkillsNowDropdown">
                    <div class="multiselect-options">
                      <div *ngFor="let skill of skillsOptions.slice(0, -1)" class="multiselect-option">
                        <input type="checkbox" [id]="'skillNow-' + skill" [checked]="isSkillNowSelected(skill)"
                          (change)="onSkillNowChange(skill, $event)" />
                        <label [for]="'skillNow-' + skill">{{ skill }}</label>
                      </div>
                      <div class="multiselect-option other-option">
                        <input type="radio" id="skillNow-otro" [checked]="showOtherSkillNow"
                          (change)="toggleOtherSkillNow($event)" />
                        <label for="skillNow-otro">Otro:</label>
                        <input type="text" name="otherSkillNow" [(ngModel)]="otherSkillNow"
                          (ngModelChange)="updateSkillsNowString()" class="other-input" placeholder=""
                          [disabled]="!showOtherSkillNow" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>Qúe habilidades profesionales te interesaria desarrolllar en los siguientes 12 meses?
                  <!-- <span class="required">*</span> -->
                </label>
                <div class="custom-multiselect">
                  <div class="multiselect-header" (click)="toggleSkillsFutureDropdown()">
                    <span class="multiselect-placeholder">{{ getSkillsFuturePlaceholder() }}</span>
                    <i class="fa-solid fa-chevron-down" [class.rotated]="showSkillsFutureDropdown"></i>
                  </div>
                  <div class="multiselect-dropdown" *ngIf="showSkillsFutureDropdown">
                    <div class="multiselect-options">
                      <div *ngFor="let skill of skillsOptions.slice(0, -1)" class="multiselect-option">
                        <input type="checkbox" [id]="'skillFuture-' + skill" [checked]="isSkillFutureSelected(skill)"
                          (change)="onSkillFutureChange(skill, $event)" />
                        <label [for]="'skillFuture-' + skill">{{ skill }}</label>
                      </div>
                      <div class="multiselect-option other-option">
                        <input type="radio" id="skillFuture-otro" [checked]="showOtherSkillFuture"
                          (change)="toggleOtherSkillFuture($event)" />
                        <label for="skillFuture-otro">Otro:</label>
                        <input type="text" name="otherSkillFuture" [(ngModel)]="otherSkillFuture"
                          (ngModelChange)="updateSkillsFutureString()" class="other-input" placeholder=""
                          [disabled]="!showOtherSkillFuture" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mensaje de error para la sección profesional -->
      <div *ngIf="showGlobalError && isProfessionalEditMode" class="global-error-message">
        <i>{{ globalErrorMessage || 'Por favor, completa todos los campos obligatorios.' }}</i>
      </div>
      <!-- </section> -->


      <!-- Sección personal -->
      <!-- <section class="section-container"> -->
      <div class="section-header">
        <h2 class="section-title"></h2>
      </div>

      <!-- Vista de solo lectura -->
      <div class="section-content" *ngIf="!isPersonalEditMode">
        <!-- <div class="info-item">
              <span class="label">¿Sigues vinculado al mundo laboral?</span>
              <span class="value">{{ user.personalSection?.hobbys || '-' }}</span>
            </div> -->
        <div class="info-item">
          <span class="label">¿Te gustaría participar en comunidades?</span>
          <span class="value">{{ user.personalSection?.colors || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">¿En qué tipo de comunidades te interesaría participar?</span>
          <span class="value">{{ user.personalSection?.travelDestination || '-' }}</span>
        </div>
        <!-- <div class="info-item">
              <span class="label">¿Qué tipo de interacciones prefieres?</span>
              <span class="value">{{ user.personalSection?.interactionType || '-' }}</span>
            </div> -->
        <div class="info-item">
          <span class="label">¿Qué esperas encontrar en una comunidad como Phoenix?</span>
          <span class="value">{{ user.personalSection?.phoenixExpectations || '-' }}</span>
        </div>
      </div>

      <!-- Vista de edición -->
      <div class="section-content edit-mode" *ngIf="isPersonalEditMode">
        <div class="form-grid">
          <!-- Primera fila - 2 columnas -->
          <!-- <div class="form-group">
                <label>¿Sigues vinculado al mundo laboral? <span class="required">*</span></label>
                <select name="hobbys" [(ngModel)]="user.personalSection.hobbys" class="form-select">
                  <option value="" disabled selected>Seleccione una opción</option>
                  <option *ngFor="let option of laboralOptions" [value]="option">{{ option }}</option>
                </select>
              </div> -->

          <div class="form-group">
            <label>¿Te gustaría participar en comunidades?
              <!-- <span class="required">*</span> -->
            </label>
            <select name="colors" [(ngModel)]="user.personalSection.colors" class="form-select">
              <option value="" disabled selected>Seleccione una opción</option>
              <option *ngFor="let option of communityOptions" [value]="option">{{ option }}</option>
            </select>
          </div>

          <!-- Segunda fila - 2 columnas -->
          <div class="form-group">
            <label>¿En qué tipo de comunidades te interesaría participar?
              <!-- <span class="required">*</span> -->
            </label>
            <div class="custom-multiselect">
              <div class="multiselect-header" (click)="toggleCommunityTypeDropdown()">
                <span class="multiselect-placeholder">{{ getCommunityTypePlaceholder() }}</span>
                <i class="fa-solid fa-chevron-down" [class.rotated]="showCommunityTypeDropdown"></i>
              </div>
              <div class="multiselect-dropdown" *ngIf="showCommunityTypeDropdown">
                <div class="multiselect-options">
                  <div *ngFor="let option of communityTypeOptions" class="multiselect-option">
                    <input type="checkbox" [id]="'communityType-' + option" [checked]="isCommunityTypeSelected(option)"
                      (change)="onCommunityTypeChange(option, $event)" name="communityType" />
                    <label [for]="'communityType-' + option">{{ option }}</label>
                  </div>
                  <div class="multiselect-option other-option" (click)="$event.stopPropagation()">
                    <input type="radio" id="communityType-otro" [checked]="showOtherCommunityType"
                      (change)="toggleOtherCommunityType($event)" (click)="$event.stopPropagation()"
                      name="communityType" />
                    <label for="communityType-otro" (click)="$event.stopPropagation()">Otro:</label>
                    <input type="text" name="otherCommunityType" [(ngModel)]="otherCommunityType"
                      (ngModelChange)="onOtherCommunityTypeChange()" (click)="$event.stopPropagation()"
                      class="other-input" placeholder="" [disabled]="!showOtherCommunityType" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="form-group">
                <label>¿Qué tipo de interacciones prefieres? 
                </label>
                <div class="custom-multiselect">
                  <div class="multiselect-header" (click)="toggleInteractionTypeDropdown()">
                    <span class="multiselect-placeholder">{{ getInteractionTypePlaceholder() }}</span>
                    <i class="fa-solid fa-chevron-down" [class.rotated]="showInteractionTypeDropdown"></i>
                  </div>
                  <div class="multiselect-dropdown" *ngIf="showInteractionTypeDropdown">
                    <div class="multiselect-options">
                      <div *ngFor="let option of interactionOptions" class="multiselect-option">
                        <input 
                          type="checkbox" 
                          [id]="'interactionType-' + option" 
                          [checked]="isInteractionTypeSelected(option)"
                          (change)="onInteractionTypeChange(option, $event)"
                          name="interactionType"
                        />
                        <label [for]="'interactionType-' + option">{{ option }}</label>
                      </div>
                      <div class="multiselect-option other-option" (click)="$event.stopPropagation()">
                        <input 
                          type="radio" 
                          id="interactionType-otro" 
                          [checked]="showOtherInteractionType"
                          (change)="toggleOtherInteractionType($event)"
                          (click)="$event.stopPropagation()"
                          name="interactionType"
                        />
                        <label for="interactionType-otro" (click)="$event.stopPropagation()">Otro:</label>
                        <input 
                          type="text" 
                          name="otherInteractionType" 
                          [(ngModel)]="otherInteractionType"
                          (ngModelChange)="onOtherInteractionTypeChange()"
                          (click)="$event.stopPropagation()"
                          class="other-input"
                          placeholder=""
                          [disabled]="!showOtherInteractionType"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
        </div>

        <!-- Quinta pregunta - ancho completo -->
        <div class="form-group full-width">
          <label>¿Qué esperas encontrar en una comunidad como Phoenix? <!-- <span class="required">*</span> --></label>
          <div class="input-container">
            <input type="text" name="phoenixExpectations" [(ngModel)]="user.personalSection.phoenixExpectations"
              placeholder="Ingrese (respuesta corta, limitar caracteres)" class="form-input"
              [maxlength]="maxPhoenixExpectationsLength">
            <div class="char-counter">
              <span [class.warning]="getRemainingChars() <= 20" [class.danger]="getRemainingChars() <= 10">
                {{ getRemainingChars() }}
              </span>
              <span class="char-counter-text">/ {{ maxPhoenixExpectationsLength }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Botón de guardar para desktop -->
    <div class="desktop-save-container" *ngIf="isGeneralEditMode()">
      <button class="btn-save-desktop" type="button" [disabled]="!hasChanges()" (click)="saveChanges()">
        <i class="fa-solid fa-check"></i>
        Guardar cambios
      </button>
    </div>

    <div *ngIf="showGlobalError" class="global-error-message">
      <i>{{ globalErrorMessage || 'Por favor, completa todos los campos obligatorios.' }}</i>
    </div>
  </div>
</form>

<!-- Footer fijo para móvil cuando está en modo edición -->
<div *ngIf="isEditMode || isProfessionalEditMode || isPersonalEditMode" class="mobile-edit-footer">
  <button class="save-button" [disabled]="!hasChanges()" (click)="saveChanges()">
    <i class="fa-solid fa-check"></i>
    Guardar cambios
  </button>
</div>

<!-- Modal de perfil completado -->
<div *ngIf="showProfileCompleteModal" class="profile-complete-modal-overlay">
  <div class="profile-complete-modal">
    <div class="modal-header">
      <img src="assets/img/profileComplete.jpg" alt="Perfil completado" class="modal-background-image">
    </div>
    <div class="modal-content">
      <h2 class="modal-title">¡Perfil completado {{ user.firstName }}!</h2>
      <p class="modal-description">
        Gracias por darte el tiempo de contarnos más sobre ti, con esta información podremos acompañarte mejor y
        ofrecerte experiencias que realmente se adapten a tus necesidades. Ahora te llevaremos a tu inicio donde
        empezarás a explorar todo lo que Phoenix tiene preparado para ti.
      </p>
      <button class="modal-button" (click)="continueToDashboard()">
        CONTINUAR
      </button>
    </div>
  </div>
</div>